<template>
  <div>
    <div class="row">
      <div class="col-6">
        <div class="mx-4 d-flex flex-column">
          <div>
            <h5 class="py-3">動態/靜態</h5>
            <el-select v-model="IsDynamicMode" class="m-2" placeholder="Select" id="modeVertical">
              <el-option v-for="item in modeVertical" :key="item.value" :label="item.label"
                         :value="item.value" />
            </el-select>
          </div>
          <div>
            <h5 class="py-3">動畫模式</h5>
            <el-select v-model="AnimateMode" class="m-2" placeholder="Select" id="modeVertical">
              <el-option v-for="item in AnimateModeVertical" :key="item.value" :label="item.label"
                         :value="item.value" />
            </el-select>
          </div>
        </div>
      </div>
      <div v-if="IsDynamicMode === 'dynamic'" class="col-6">
        <h5 class="py-3">Sensor</h5>
        <el-select v-model="Sensor" class="m-2" placeholder="Select" id="modeVertical">
          <el-option v-for="item in SensorVertical" :key="item.value" :label="item.label"
                     :value="item.value" />
        </el-select>
        <div class="mx-4">
          <div class="py-2">
            <div>
              <label class="me-3" for="minTemp">最低</label>
              <input class="w-25" type="number" v-model.lazy="minTempInput"
                     id="minTemp">
            </div>
            <div class="py-2">
              <label class="me-3" for="maxTemp">最高</label>
              <input class="w-25" type="number" v-model.lazy="maxTempInput"
                     id="maxTemp">
            </div>
          </div>
        </div>
      </div>
      <div v-else class="col-6">
        <div class="mx-4">
          <h5 class="py-3">速度控制</h5>
          <div class="py-2">
            <el-select v-model="speed" class="m-2" placeholder="Select" id="modeVertical">
              <el-option v-for="item in speedVertical" :key="item.value" :label="item.label"
                         :value="item.value" />
            </el-select>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <div class="mx-4">
          <h5 class="py-3">文字控制</h5>
          <div>
            <label class="me-3" for="textMode">選擇文字模式</label>
            <el-select v-model="textModeValue" class="m-2" id="textMode" @change="handleChangeTextMode">
              <el-option v-for="item in textMode" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </div>
<!--          <div v-if="textModeValue !== 'None'">-->
<!--            <label class="me-3" for="fontFamilyMode">選擇字體</label>-->
<!--            <el-select v-model="fontFamily" class="m-2" id="fontFamilyMode" >-->
<!--              <el-option v-for="item in fontFamilyVertical" :key="item.value" :label="item.label" :value="item.value" />-->
<!--            </el-select>-->
<!--          </div>-->
        </div>
      </div>
      <template v-if="textModeValue === 'SliderSensor' || textModeValue === 'Time'">
        <div class="col-6" v-if="textModeValue === 'SliderSensor'">
          <div class="mx-4">
            <div class="me-3" >Controller選擇 (可複選)</div>
            <div class="d-flex flex-wrap">
              <div class="m-2" v-for="controller in showTextsList" :key="controller">
                <input class="me-1" type="checkbox" :id="controller" :value="controller"
                       v-model="controllerSelected" @change="limitCheckbox">
                <label class="fw-bold" :for="controller">{{ controller }}</label>
              </div>
            </div>
            <div class="m-2">
              <label class="fw-bold me-1" for="loopSecond">Loop Second</label>
              <input class="me-1" type="number" id="loopSecond"
                     v-model="controllerLoopSecond">
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="my-3">
            <label class="me-3" for="textBoxPositionHorizontal">選擇水平方向</label>
            <el-select v-model="horizontalValue" class="m-2" id="textBoxPositionHorizontal">
              <el-option v-for="item in textBoxPositionHorizontal" :key="item.value" :label="item.label"
                         :value="item.value" />
            </el-select>
          </div>
          <div class="my-3">
            <label class="me-3" for="textBoxPositionVertical">選擇垂直方向</label>
            <el-select v-model="verticalValue" class="m-2" id="textBoxPositionVertical">
              <el-option v-for="item in textBoxPositionVertical" :key="item.value" :label="item.label"
                         :value="item.value" />
            </el-select>
          </div>
          <div class="my-3">
            <label class="me-3" for="textBoxPositionVertical">選擇文字方向</label>
            <el-select v-model="textAlignmentValue" class="m-2" id="textBoxPositionVertical">
              <el-option v-for="item in textAlignments" :key="item.value" :label="item.label"
                         :value="item.value" />
            </el-select>
          </div>
          <div class="my-3">
            <label class="me-5">Label 顏色</label>
            <el-color-picker color-format="rgb" v-model="labelTextColor[0]" />
            <el-color-picker color-format="rgb" v-model="labelTextColor[1]" />
            <el-color-picker color-format="rgb" v-model="labelTextColor[2]" />
          </div>
        </div>
      </template>
      <template v-else-if="textModeValue === 'Custom'">
        <div class="col-6">
          <CustomTextInput
              v-model:custom-texts="customText"
              v-model:text-color="customLabelTextColor"
              v-model:text-fz="fontSize"
              mode="center"
              :effect="props.effectName"
          />
        </div>
        <div class="col-6">
          <div class="my-3">
            <label class="me-3" for="textBoxPositionHorizontal">選擇水平方向</label>
            <el-select v-model="horizontalValue" class="m-2" id="textBoxPositionHorizontal">
              <el-option v-for="item in textBoxPositionHorizontal" :key="item.value" :label="item.label"
                         :value="item.value" />
            </el-select>
          </div>
          <div class="my-3">
            <label class="me-3" for="textBoxPositionVertical">選擇垂直方向</label>
            <el-select v-model="verticalValue" class="m-2" id="textBoxPositionVertical">
              <el-option v-for="item in textBoxPositionVertical" :key="item.value" :label="item.label"
                         :value="item.value" />
            </el-select>
          </div>
          <div class="my-3">
            <label class="me-3" for="textBoxPositionVertical">選擇文字方向</label>
            <el-select v-model="textAlignmentValue" class="m-2" id="textBoxPositionVertical">
              <el-option v-for="item in textAlignments" :key="item.value" :label="item.label"
                         :value="item.value" />
            </el-select>
          </div>
        </div>
      </template>
      <div class="col-6">
        <div>
          <label class="me-3" >文字陰影</label>
          <div class="d-flex">
            <el-slider v-model="textShadow" />
            <input class="w-25 ms-3" type="number" name="" id="" v-model="textShadow">
          </div>
        </div>
        <div>
          <label class="me-3">文字透明度</label>
          <div class="d-flex">
            <el-slider v-model="textOpacity" />
            <input class="w-25 ms-3" type="number" name="" id="" v-model="textOpacity">
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <WaterMarkImage
            v-model:water-mark-image-file-name="waterMarkImageFileName"
            v-model:wm-opacity="wmOpacity"
            v-model:wm-shadow="wmShadow"
            v-model:wm-horizontal="wmHorizontal"
            v-model:wm-vertical="wmVertical"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <button type="button" class="btn btn-primary mx-2" @click.stop="handleSubmit">確認</button>
        <button type="button" class="btn btn-secondary mx-2" @click.stop="handleInit">清空</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive } from 'vue'
import CustomTextInput from '@/components/controllerMode/comp/TextInputComp.vue'
import WaterMarkImage from "@/components/controllerMode/comp/WaterMarkImageComp.vue";

import defaultValue from "@/utils/defaultValue";
import ColorTool from "@/utils/colorTool";

import freeImg from "@/utils/freeImg";

const {
  watermarkImages
} = freeImg()

const {
  modeVertical,
  SensorVertical,
  showTextsList,
  textMode,
  textAlignments
} = defaultValue()

const {getRgbFilterString} = ColorTool()

const emit = defineEmits(['getTempControlData'])
const props = defineProps(['effectName'])
const tempControlData = reactive({
  Theme: {},
  Text: {},
  Watermark: {}
})

//////文字控制/////
const fontFamily = ref('')
let fontSize = ref(42)
const controllerSelected = ref([]) // sensor
const controllerLoopSecond = ref(5) // 循環秒數

const textModeValue = ref('None')

const textBoxPositionVertical = reactive([
  { value: 'Center', label: 'vertical-center' }
])
const textBoxPositionHorizontal = reactive([
  { value: 'Center', label: 'horizontal-center' }
])

// 垂直方向
const verticalValue = ref('Center')

// 水平方向
const horizontalValue = ref('Center')

// 文字對齊
const textAlignmentValue = ref('Center')



const labelTextColor = ref(['rgb(130, 229, 245)', 'rgb(255, 255, 255)', 'rgb(131, 254, 234)'])

let customText = ref([])
let customLabelTextColor = ref(['rgb(130, 229, 245)'])

const AnimateModeVertical = [
  { value: '12', label: '12' },
  // { value: '24', label: '24' },
  { value: '36', label: '36' },
  { value: '48', label: '48' },
  { value: '60', label: '60' },
  { value: '72', label: '72' },
  // { value: '84', label: '84' },
  { value: '96', label: '96' },
  // { value: '108', label: '108' },
  { value: '120', label: '120' },
]

const textOpacity = ref(100)
const textShadow = ref(35)
const bgColor = ref('rgb(0,0,0)')




function handleChangeTextMode (item) {
  if (item === 'None') {
    // init
    fontFamily.value = ''
    controllerSelected.value = []
    controllerLoopSecond.value = 5
    verticalValue.value = 'Center'
    horizontalValue.value = 'Center'
    labelTextColor.value = ['rgb(130, 229, 245)', 'rgb(255, 255, 255)', 'rgb(131, 254, 234)']
  }
}

const limitCheckbox = () => {
  let maxNum = 4
  if (controllerSelected.value.length > maxNum) controllerSelected.value.splice(0, 1)
}
/////浮水印控制/////

const wmOpacity = ref(50)
const wmHorizontal = ref(50)
const wmVertical = ref(50)
const wmShadow = ref(50)

const waterMarkImageFileName = ref('')

// Sensor
const Sensor = ref('CPULoad')
// 動態/靜態
const IsDynamicMode = ref('static')
// 動畫模式
const AnimateMode = ref('12')

/////溫度控制///////
const maxTempInput = ref(70)
const minTempInput = ref(20)



const speed = ref(1)
const speedVertical = reactive([
  { value: 1, label: '1' },
  { value: 2, label: '2' },
  { value: 3, label: '3' },
  { value: 4, label: '4' },
  { value: 5, label: '5' },
  { value: 6, label: '6' },
  { value: 7, label: '7' },
  { value: 8, label: '8' },
  { value: 9, label: '9' },
  { value: 10, label: '10' },
])

function handleSubmit () {
  let BackgroundColor = []
  if (bgColor.value.indexOf('rgb(') >= 0) BackgroundColor = getRgbFilterString(bgColor.value)
  let FontColors = labelTextColor.value.map(item => getRgbFilterString(item))


  if (IsDynamicMode.value === 'static') {
    Object.assign(tempControlData.Theme, {
      Effect: props.effectName,
      IsDynamicMode: false,
      Colors: [],
      AnimateMode: AnimateMode,
      Speed: speed.value, // min 1.2, max 2
      BackgroundColor: BackgroundColor
    })
  } else {
    Object.assign(tempControlData.Theme, {
      Effect: props.effectName,
      IsDynamicMode: true,
      Sensor: Sensor,
      HighValue: maxTempInput,
      LowValue: minTempInput,
      HighColors: [],
      LowColors: [],
      BackgroundColor: BackgroundColor,
      AnimateMode: AnimateMode
    })
  }

  if (textModeValue.value === 'None') {
    Object.assign(tempControlData.Text, {
      Type: textModeValue.value
    })
  }
  else if (textModeValue.value === 'SliderSensor' || textModeValue.value === 'Time') {
    Object.assign(tempControlData.Text, {
      Type: textModeValue.value,
      Sensors: controllerSelected.value,
      LoopSecond: controllerLoopSecond.value,
      Layout: [
        {
          HorizontalAlignment: horizontalValue.value,
          VerticalAlignment: horizontalValue.value,
          TextAlignment: textAlignmentValue.value,
          FontColors: FontColors,
          Shadow: textShadow.value,
          Opacity: textOpacity.value,
          FontFamily: fontFamily.value
        }
      ]
    })
  }
  else if (textModeValue.value === 'Custom') {

    let customLabelTextColors = customLabelTextColor.value.map(item => getRgbFilterString(item))

    Object.assign(tempControlData.Text, {
      Type: textModeValue.value,
      Text: customText.value,
      Layout: [
        {
          HorizontalAlignment: horizontalValue.value,
          VerticalAlignment: verticalValue.value,
          TextAlignment: textAlignmentValue.value,
          FontColors: customLabelTextColors,
          Shadow: textShadow.value,
          Opacity: textOpacity.value,
          FontFamily: fontFamily.value,
          FontSize: fontSize.value
        }
      ]
    })
  }

  // 浮水印
  Object.assign(tempControlData.Watermark, {
    "HasImage": waterMarkImageFileName.value !== '',
    "Image": waterMarkImageFileName.value !== '' ? waterMarkImageFileName.value : '',
    "Horizontal": wmHorizontal.value,
    "Vertical": wmVertical.value,
    "Shadow": wmShadow.value,
    "Opacity": wmOpacity.value
  })

  emit('getTempControlData', tempControlData)

}

function handleInit () {

}

</script>

<style scoped>
.control-block {
  width: 33%;
}
</style>
